<template lang="pug">
footer.footer
  .footer-social(v-if="show_social_links")
    a(v-for="(social_link, social_id) in social_list", :key="social_id", :href="social_link", target="_blank")
      i.icon(:class="getClassIcon(social_id)")

  .footer__groups
    .footer__group.type-sg
      img(src="~@static_promo_pages/common/components/footer/images/logo-smilegate.svg")
    .footer__group.type-as
      img(src="~@static_promo_pages/common/components/footer/images/logo-astrum.svg")
    .footer__group.type-mg
      img(src="~@static_promo_pages/common/components/footer/images/logo-vkplay.svg")

  .footer__copyright
    p(v-html="getCopyrightText")
    p(v-html="$t('footer.copyright2')")

  .footer__links
    a.footer__link(v-for="link, link_id in additionalLinks", :key="link_id", :href="link.url", target="_blank") {{ link.text }}
    a.footer__link(href="https://support.astrum.top/la", target="_blank") Поддержка
    a.footer__link(:href="getEULALink()", target="_blank") Лицензионное соглашение
    .footer-pegi
      span 12+

</template>

<script>
export default {
  name: "PromoFooter",

  props: {
    additionalLinks: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      show_social_links: false,
      social_list: {
        vkontakte: "https://vk.com/lostark",
        youtube: "https://www.youtube.com/channel/UCcqCr5SYijJfXouNB79pzLw",
        discord: "https://discord.gg/aNXUwQM",
        // instagram: "https://www.instagram.com/lost.ark.ru",
        odnoklassniki: "https://ok.ru/group/54524030353588",
        twitch: "https://www.twitch.tv/lostark_ru",
        telegram: "https://t.me/playlostark_ru",
      },
    };
  },

  computed: {
    getCopyrightYear() {
      return new Date().getFullYear();
    },
    getCopyrightText() {
      return `©${this.getCopyrightYear} ${this.$t("footer.copyright1")}`;
    },
    getTermsUrls() {
      return this.$store.getters["terms/getUrls"];
    },
  },

  methods: {
    getClassIcon(type) {
      return `icon-social-${type}`;
    },
    getEULALink() {
      if (!this.getTermsUrls) {
        return "https://documentation.astrum.top/gameterms/eula_general/";
      } else {
        return this.getTermsUrls.filter(item => item.en === "General End User Licence Agreement")[0].url;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../style/footer.scss";
</style>
